<template>
  <div>
    <ForgetPassword isReset @submit="submit"></ForgetPassword>
  </div>
</template>

<script>
import ForgetPassword from './ForgetPassword.vue'
import * as Api from '@/api'
import { AESUtil } from '@/utils/'
export default {
  name: 'ResetPassword',
  components: {
    ForgetPassword
  },
  data() {
    return {}
  },
  methods: {
    submit(forgetPasswordForm) {
      const { password, oldPassword } = forgetPasswordForm;
      const params = {
        password: AESUtil.aesEncrypt(password),
        oldPassword: AESUtil.aesEncrypt(oldPassword)
      }
      Api.changePwd(params).then((res) => {
        if (res.code === 1) {
          this.$message.success(this.$lang('修改密码成功'))
          this.$router.push({ path: '/login' })
          localStorage.removeItem('resetData')
        } else {
          this.$message.error(this.$lang(res.msg))
        }
      })
    }
  }
}
</script>